import React, { useState, useEffect, useRef } from 'react';
import { Badge, Modal, Dropdown, Tab, Tabs, Button, Form, Stack, Table, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPaperPlane, faPaperclip, faCircleXmark, faCalendarDays, faPencil, faDownload, faFileArrowDown } from '@fortawesome/free-solid-svg-icons';

import "../../../assets/css/servicerecovery/servicerecovery.css";

import { Link } from 'react-router-dom';
import create_icon from "../../../assets/images/recovery_inbox/create-icon.svg";
import inbox_icon from "../../../assets/images/recovery_inbox/inbox-icon.svg";
import import_icon from "../../../assets/images/recovery_inbox/import-icon.svg";
import sent_icon from "../../../assets/images/recovery_inbox/sent-icon.svg";
import drop_arrow from "../../../assets/images/recovery_inbox/drop-arrow.svg";
import green_tag from "../../../assets/images/recovery_inbox/green-tag.svg";
import orange_tag from "../../../assets/images/recovery_inbox/orange-tag.svg";
import red_flag from "../../../assets/images/recovery_inbox/red-flag.svg";
import grey_tag from "../../../assets/images/recovery_inbox/grey-tag.svg";
import blue_tag from "../../../assets/images/recovery_inbox/blue-tag.svg";
import msg_icon from "../../../assets/images/recovery_inbox/msg-icon.svg";
import filter_icon from "../../../assets/images/recovery_inbox/filter-icon.svg";
import green_tag_sm from "../../../assets/images/recovery_inbox/green-tag-sm.svg";
import red_tag_sm from "../../../assets/images/recovery_inbox/red-tag-sm.svg";
import orange_tag_sm from "../../../assets/images/recovery_inbox/orange-tag-sm.svg";
import left_arrow from "../../../assets/images/recovery_inbox/left-arrow.svg";
import left_arrow_1 from "../../../assets/images/recovery_inbox/left-arrow-1.svg";
import right_arrow from "../../../assets/images/recovery_inbox/right-arrow.svg";
import star from "../../../assets/images/recovery_inbox/star.svg";
import reply_arrow_1 from "../../../assets/images/recovery_inbox/reply-arrow-1.svg";
import reply_arrow_2 from "../../../assets/images/recovery_inbox/reply-arrow-2.svg";
import calender from "../../../assets/images/recovery_inbox/calender.svg";
import clock from "../../../assets/images/recovery_inbox/clock.svg";
import pdf from "../../../assets/images/recovery_inbox/pdf.png";
import figma from "../../../assets/images/recovery_inbox/figma.png";
import cross from "../../../assets/images/recovery_inbox/cross.svg";
import plus_1 from "../../../assets/images/recovery_inbox/plus-1.svg";
import delete_icon from "../../../assets/images/recovery_inbox/delete-icon.svg";
import user_img from "../../../assets/images/recovery_inbox/user-img.png";
import link from "../../../assets/images/recovery_inbox/link.svg";
import sent_reply from "../../../assets/images/recovery_inbox/sent-reply.svg";
import forword_icon from "../../../assets/images/recovery_inbox/forword-icon.svg";
import Notemail from "../../../assets/images/recovery_inbox/notemail.png";
import Attach_new from "../../../assets/images/recovery_inbox/attach.png";
import Mail_send from "../../../assets/images/recovery_inbox/send_icon.png";

import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import Select from 'react-select';
import Docmnt from '../../../assets/images/file.svg';
import { toast } from 'react-toastify';
import { saveAs } from "file-saver";

import { withRFSToken } from '../../../Services/axios';
import { RECOVERYDETAILS } from '../../../Utils/conts';
import MessageBox from '../../../Components/common/MessageBox';
// import AddRecovery from './common/AddRecovery';

const Inbox = () => {

    const isMounted = useRef(false);
    const init = localStorage.getItem('MailTab')
    const [mailSec, setMailSec] = useState(init || 'inbox');
    const [searchItems, setSearchItems] = useState([])
    const [allMails, setAllMails] = useState([]);
    const [selectedMail, setSelectedMail] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);
    const [selectedPriorities, setSelectedPriorities] = useState([]);

    const [createMail, setCreateMail] = useState(false);
    const [mailForm, setMailForm] = useState({ type: 'H' });
    const [getEmail, setGetEmail] = useState([]);
    const [replyMail, setReplyMail] = useState(null);

    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);
    const [files, setFiles] = useState([]);

    const [selectedFile, setSelectedFile] = useState("");
    const [imgShow, setImgShow] = useState(false);
    const [assignModal, setAssignModal] = useState(false);

    const fetchData = async (sec, prio) => {
        let payload = { type: sec }
        if (prio?.length) {
            payload = { type: sec, priority: prio }
        }
        try {
            const res = await withRFSToken.post('service-recovery-mail/list', payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setAllMails(innerData);
                    // const transformedData = innerData?.all_list.map((name, index) => ({
                    //     id: index,
                    //     name: name.message
                    // }));
                    const transformedData = Array.from(
                        new Set(innerData?.all_list.map((item) => item.message))
                    )
                        .sort() // .sort(customSortFn)
                        .map((message, index) => ({
                            id: index,
                            name: message
                        }));
                    setSearchItems(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results)
        if (string.trim() === '') { fetchData(mailSec) }
    }

    const handleOnHover = (result) => {
        // the item hovered
        console.log(result)
    }
    const handleOnFocus = () => {
        // console.log('Focused')
    }
    const handleOnSelect = async (item) => {
        const matchingMessages = allMails?.all_list?.filter(mail => mail.message === item.name);
        // setAllMails(matchingMessages)
        setAllMails(prevFormData => ({
            ...prevFormData,
            all_list: matchingMessages
        }))
    }

    useEffect(() => {
        if (isMounted.current) return;
        fetchData(mailSec);
        console.log('mailSec', mailSec);

        isMounted.current = true;
    }, []);

    const options = [];

    const fetchDetails = async (mailId, index, pos) => {
        const sameDetails = selectedMail?.data?.find(i => i.id == mailId);
        if (!sameDetails || pos) {
            handleReplyClose()
            let payload = {};
            if (pos == 'R') {
                payload = {
                    message_id: selectedMail.details.message_id,
                    service_recovery_id: selectedMail.details.service_recovery_id,
                    station_handler_id: selectedMail.details.station_handler_id,
                    parent_id: selectedMail.details.parent_id
                }
            } else {
                payload = {
                    message_id: mailId.message_id,
                    service_recovery_id: mailId.service_recovery_id,
                    station_handler_id: mailId.station_handler_id,
                    parent_id: mailId.parent_id
                }
            }
            try {
                const res = await withRFSToken.post('service-recovery-mail/details', payload)
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        setSelectedMail(innerData);
                        setSelectedIndex(index);
                        const unReadId = allMails?.all_list?.find(mid => mid.id == mailId);
                        if (unReadId.is_seen == 0 && (mailSec !== 'unread')) {
                            fetchData(mailSec);
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    const formatCreatedAt = (createdAt) => {
        const now = new Date();
        const createdDate = new Date(createdAt);

        const isSameDate =
            now.getFullYear() === createdDate.getFullYear() &&
            now.getMonth() === createdDate.getMonth() &&
            now.getDate() === createdDate.getDate();

        if (isSameDate) {
            // Return time in HH:MM AM/PM format
            return createdDate.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            });
        } else {
            // Return month name and date
            return createdDate.toLocaleDateString('en-US', {
                month: 'long',
                day: '2-digit',
            });
        }
    };
    const formatDetailsDate = (created_at) => {
        const dateObj = new Date(created_at);

        const formattedTime = dateObj.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        });
        return formattedTime
    }
    const formatDetailsTime = (created_at) => {
        const dateObj = new Date(created_at);

        const formattedTime = dateObj.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
        });
        return formattedTime
    }

    const handlePriorityChange = (priorityLabel, checked) => {
        setSelectedPriorities((prev) => {
            const updated = checked ? [...prev, priorityLabel] : prev.filter((item) => item !== priorityLabel);

            fetchData(mailSec, updated);
            return updated;
        });
    };

    const handleTabClick = (sec) => {
        setMailSec(sec);
        fetchData(sec);
        localStorage.setItem('MailTab', sec)
        setSelectedMail(null)
        setSelectedIndex(null);
    }

    const createMailOpen = () => {
        handleReplyClose();
        setCreateMail(true);
    }
    const createMailClose = () => {
        setCreateMail(false);
        setMailForm({ type: 'H' });
        setFiles([])
    }

    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setMailForm(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }
    // IMAGE UPLOAD START

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);

            // Update local storage
            setMailForm((prevFormData) => {
                const newFiles = prevFormData ? [...prevFormData.attachments] : [];
                newFiles.splice(index, 1);
                return { ...prevFormData, attachments: newFiles };
            });

            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = mailForm?.attachments || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                    const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                    // setFiles(newFiles);
                    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setBase64Files(mergedBase64Files);
                    setMailForm((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
    };
    // IMAGE UPLOAD END

    const handleGetMail = async (val) => {
        if (val.length == 13) {
            try {
                const res = await withRFSToken.post('service-recovery-mail/get-handler-emails', { awbNumber: val })
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        // setMailForm({ ...mailForm, service_recovery_id: innerData.service_recovery_id })
                        setMailForm(prevFormData => ({
                            ...prevFormData,
                            service_recovery_id: innerData.service_recovery_id
                        }))
                        const transMail = innerData ? innerData.receiver_data.map(item => ({
                            value: item.receiver_id,
                            email: item.receiver_email,
                            label: item.handler_name + ' - ' + item.station_name + ' (' + item.receiver_email + ')',
                        })) : [];
                        setGetEmail(transMail);
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }
    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };
    const handleMailChange = (fieldName, value) => {
        // const { name, value } = e.target;
        if (fieldName == 'awbNumber') {
            console.log('vvv');

            value = handleChange(value);
            handleGetMail(value)
        }
        setMailForm(prevFormData => ({
            ...prevFormData,
            [fieldName]: value
        }))
    };

    const validateMailData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!mailForm.receiver) {
            toast.error('Invalid email address');
            isValid = false;
        } else if (mailForm.receiver[0].receiver_email == '') {
            toast.error('Insert valid email address');
            isValid = false;
        } else if (!mailForm.type) {
            toast.error('Company Name must not be blank');
            isValid = false;
        } else if (!mailForm.subject) {
            toast.error('Please enter Subject');
            isValid = false;
        } else if (mailForm.awbNumber && mailForm.awbNumber.length !== 13) {
            toast.error('Please enter proper AWB Number');
            isValid = false;
        } else if (!mailForm.message) {
            toast.error('Please enter message');
            isValid = false;
        }
        else {
            return isValid;
        }
    };
    const sendMessage = async (pos, index) => {
        if (validateMailData()) {
            try {
                const res = await withRFSToken.post('service-recovery-mail/save', mailForm)
                    .then(function (res) {

                        toast.success(res.data.response_msg);
                        setCreateMail(false);

                        setFiles([])
                        if (pos == 'R') {
                            setReplyMail(null)
                            fetchDetails(mailForm, index, 'R');
                            setMailForm({ type: 'H' });
                        } else {
                            fetchData(mailSec);
                            setMailForm({ type: 'H' });
                        }
                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    };

    const handleReply = (data, index) => {
        setReplyMail(index);
        setMailForm({
            ...mailForm,
            id: data.id,
            subject: data.subject,
            awbNumber: data.awbNumber,
            service_recovery_id: data.service_recovery_id,
            parent_id: data.parent_id,
            receiver: [{ receiver_email: data.sender_email, receiver_id: data.sender_id }]
        })
    }
    const handleReplyClose = () => {
        setReplyMail(null);
        setMailForm({ type: 'H' });
        setFiles([])
    }
    const loadDetails = async (uldNumber) => {
        if (uldNumber !== 'Not found') {
            localStorage.removeItem('RecoveryEdit');
            localStorage.setItem('RecoveryEdit', JSON.stringify(uldNumber));
            const fnPageUrl = '/OverviewDetails';
            window.location.href = fnPageUrl;
            // try {
            //     const res = await withRFSToken.post(RECOVERYDETAILS, { service_recovery_id: uldNumber })
            //         .then(function (res) {
            //             const innerData = res.data.response_data;
            //             // console.log("🚀 ~ .then ~ innerData:654", innerData)

            //             localStorage.removeItem('RecoveryEdit');
            //             localStorage.setItem('RecoveryEdit', JSON.stringify(innerData));
            //             // const fnPageUrl = '/OverviewDetails';
            //             // window.location.href = fnPageUrl;

            //         });
            // } catch (error) {
            //     console.error('Error fetching data:', error);
            // }
        }
    };

    const handleFileClick = () => {

    }
    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };

    const [checkAwb, setCheckAwb] = useState()
    const [assignId, setAssignId] = useState('')
    const [checkAwbData, setCheckAwbData] = useState({})
    const [isCheck, setIsCheck] = useState(false)
    const [addNewRecord, setAddNewRecord] = useState(false)
    const handleAsignAwb = (id, index) => {
        setAssignModal(true);
        setAssignId(id)
    }
    const fetchAwb = async (awbNum) => {
        try {
            const res = await withRFSToken.post('service-recovery-mail/get-handler-emails', { awbNumber: awbNum, type: 'assignAwb' })
                .then(function (res) {
                    const innerData = res.data.response_data.receiver_data;
                    setCheckAwb(innerData)
                    setIsCheck(true)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleInputChange = (fieldName, value) => {
        if (fieldName === 'airway_bill') {
            value = handleChange(value);
        }
        setCheckAwbData(prev => ({
            ...prev,
            [fieldName]: value
        }));
        if (value.length == 13) { fetchAwb(value) }
    };
    const closeConfirm = () => {
        setAssignModal(false)
        setIsCheck(false)
        setCheckAwbData({})
    }
    const createNewRecord = () => {
        setAddNewRecord(true)
    }
    const handleAssign = async () => {
        try {
            const res = await withRFSToken.post('service-recovery-mail/update-awb-number', { inbox_id: assignId, service_recovery_id: checkAwb[0].service_recovery_id })
            if (res.data.response_code === 200) {
                const innerData = res.data.response_data;
                fetchData(mailSec)
                fetchDetails(innerData)
                setAssignModal(false);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const closeNewRecord = () => {
        setAddNewRecord(false)
    }
    const saveNewRecord = () => {
        fetchAwb(checkAwbData.airway_bill)
        setAddNewRecord(false)
    }

    return (
        <>
            {console.log('selectedMail', selectedMail)}
            {/* {addNewRecord && <AddRecovery onClose={closeNewRecord} onSubmit={saveNewRecord} />} */}
            <div className="cargohub-inbox-sec">
                <Row>
                    <Col lg={2} className="p-0">
                        <div className="create-div-main">
                            <div className="create-div-main-left">
                                <div className="create-div" onClick={createMailOpen}>
                                    <div className="create-text">
                                        <h3>Create</h3>
                                    </div>
                                    <div className="create-icon">
                                        <img src={create_icon} alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="inbox-sm-div-main-list">
                                <ul>
                                    <li>
                                        <Link to="#" onClick={() => handleTabClick('inbox')}>
                                            <div className={`inbox-sm-div-main ${mailSec == 'inbox' ? 'inbox-sm-active' : ''}`}>
                                                <div className="inbox-sm-div-left">
                                                    <div className="inbox-icon">
                                                        <img src={inbox_icon} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>Inbox</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right inbox-num">
                                                    <h4>{allMails?.dashboard?.inbox}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" onClick={() => handleTabClick('unread')}>
                                            <div className={`inbox-sm-div-main  ${mailSec == 'unread' ? 'inbox-sm-active' : ''}`}>
                                                <div className="inbox-sm-div-left">
                                                    <div className="inbox-icon">
                                                        <img src={import_icon} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>Unread</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right">
                                                    <h4>{allMails?.dashboard?.total_unread}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" onClick={() => handleTabClick('noawb')}>
                                            <div className={`inbox-sm-div-main ${mailSec == 'noawb' ? 'inbox-sm-active' : ''}`}>
                                                <div className="inbox-sm-div-left">
                                                    <div className="inbox-icon">
                                                        <img src={import_icon} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>No AWB</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right">
                                                    <h4>{allMails?.dashboard?.no_awb}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" onClick={() => handleTabClick('sent')}>
                                            <div className={`inbox-sm-div-main ${mailSec == 'sent' ? 'inbox-sm-active' : ''}`}>
                                                <div className="inbox-sm-div-left">
                                                    <div className="inbox-icon">
                                                        <img src={sent_icon} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>Sent</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right">
                                                    <h4>{allMails?.dashboard?.sent}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div className="priority-level-main-list">
                                <ul>
                                    <li>
                                        <Link to="#">
                                            <div className="priority-level-div">
                                                <div className="priority-level-text">
                                                    <h4>Priority Level</h4>
                                                </div>
                                                <div className="priority-level-icon">
                                                    <img src={drop_arrow} alt="" />
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>

                                        {/* <Link to="#"> */}
                                        <div className="inbox-sm-div-main">
                                            <div className="inbox-sm-div-left">
                                                <Form.Check // prettier-ignore
                                                    type="checkbox"
                                                    id={`priority-low`}
                                                    checked={selectedPriorities.includes('Low')}
                                                    onChange={(e) => handlePriorityChange('Low', e.target.checked)}
                                                    className='priority_check'
                                                />
                                                <div className="inbox-icon">
                                                    <img src={green_tag} alt="" />
                                                </div>
                                                <div className="inbox-text">
                                                    <h4>Low</h4>
                                                </div>
                                            </div>
                                            <div className="inbox-sm-div-right">
                                                <h4>{allMails?.dashboard?.priority?.Low}</h4>
                                            </div>
                                        </div>
                                        {/* </Link> */}
                                    </li>
                                    <li>

                                        {/* <Link to="#"> */}
                                        <div className="inbox-sm-div-main">
                                            <div className="inbox-sm-div-left">
                                                <Form.Check // prettier-ignore
                                                    type="checkbox"
                                                    id={`priority-Medium`}
                                                    checked={selectedPriorities.includes('Medium')}
                                                    onChange={(e) => handlePriorityChange('Medium', e.target.checked)}
                                                    className='priority_check'
                                                />
                                                <div className="inbox-icon">
                                                    <img src={orange_tag} alt="" />
                                                </div>
                                                <div className="inbox-text">
                                                    <h4>Medium</h4>
                                                </div>
                                            </div>
                                            <div className="inbox-sm-div-right">
                                                <h4>{allMails?.dashboard?.priority?.Medium}</h4>
                                            </div>
                                        </div>
                                        {/* </Link> */}
                                    </li>
                                    <li>
                                        {/* <Link to="#"> */}
                                        <div className="inbox-sm-div-main">
                                            <div className="inbox-sm-div-left">
                                                <Form.Check // prettier-ignore
                                                    type="checkbox"
                                                    id={`priority-Critical`}
                                                    checked={selectedPriorities.includes('Critical')}
                                                    onChange={(e) => handlePriorityChange('Critical', e.target.checked)}
                                                    className='priority_check'
                                                />
                                                <div className="inbox-icon">
                                                    <img src={red_flag} alt="" />
                                                </div>
                                                <div className="inbox-text">
                                                    <h4>Critical</h4>
                                                </div>
                                            </div>
                                            <div className="inbox-sm-div-right">
                                                <h4>{allMails?.dashboard?.priority?.Critical}</h4>
                                            </div>
                                        </div>
                                        {/* </Link> */}
                                    </li>
                                </ul>
                            </div>
                            <div className="priority-level-main-list">
                                <ul>
                                    <li>
                                        <Link to='#'>
                                            <div className="priority-level-div">
                                                <div className="priority-level-text">
                                                    <h4>Case Status</h4>
                                                </div>
                                                <div className="priority-level-icon">
                                                    <img src={drop_arrow} alt="" />
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='#'>
                                            <div className="inbox-sm-div-main">
                                                <div className="inbox-sm-div-left">
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        // id={`priority-low`}
                                                        // checked={selectedPriorities.includes('Low')}
                                                        // onChange={(e) => handlePriorityChange('Low', e.target.checked)}
                                                        className='priority_check'
                                                    />
                                                    <div className="inbox-icon">
                                                        <img src={grey_tag} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>Open</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right">
                                                    <h4>{allMails?.dashboard?.caseStatus?.open}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='#'>
                                            <div className="inbox-sm-div-main">
                                                <div className="inbox-sm-div-left">
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        // id={`priority-low`}
                                                        // checked={selectedPriorities.includes('Low')}
                                                        // onChange={(e) => handlePriorityChange('Low', e.target.checked)}
                                                        className='priority_check'
                                                    />
                                                    <div className="inbox-icon">
                                                        <img src={blue_tag} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>Recovered</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right">
                                                    <h4>{allMails?.dashboard?.caseStatus?.recovered}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to='#'>
                                            <div className="inbox-sm-div-main">
                                                <div className="inbox-sm-div-left">
                                                    <Form.Check // prettier-ignore
                                                        type="checkbox"
                                                        // id={`priority-low`}
                                                        // checked={selectedPriorities.includes('Low')}
                                                        // onChange={(e) => handlePriorityChange('Low', e.target.checked)}
                                                        className='priority_check'
                                                    />
                                                    <div className="inbox-icon">
                                                        <img src={red_flag} alt="" />
                                                    </div>
                                                    <div className="inbox-text">
                                                        <h4>Lost</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-sm-div-right">
                                                    <h4>{allMails?.dashboard?.caseStatus?.lost}</h4>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    <Col lg={3} className="p-0">
                        <div className="inbox-div-main">
                            <div className="inbox-div">
                                <div className="inbox-text-2">
                                    <h3>{mailSec == 'inbox' ? 'Inbox' : mailSec == 'unread' ? 'Unread' : mailSec == 'sent' ? 'Sent' : 'No AWB'}</h3>
                                </div>
                                <div className="inbox-msg-div">
                                    <div className="inbox-msg-left">
                                        <div className="msg-box mr-30">
                                            <div className="msg-icon">
                                                <img src={msg_icon} alt="" />
                                            </div>
                                            <div className="msg-text">
                                                {/* <h3>
                                                    {mailSec == 'inbox' ? allMails?.dashboard?.inbox
                                                        : mailSec == 'unread' ? allMails?.dashboard?.total_unread
                                                            : mailSec == 'sent' ? allMails?.dashboard?.sent
                                                                : allMails?.dashboard?.no_awb} Messages
                                                </h3> */}
                                                <h3>{allMails?.all_list?.length} Messages</h3>
                                            </div>
                                        </div>
                                        <div className="msg-box">
                                            {mailSec == 'inbox' &&
                                                <>
                                                    <div className="msg-icon">
                                                        <img src={msg_icon} alt="" />
                                                    </div>
                                                    <div className="msg-text">
                                                        <h3>{allMails?.dashboard?.total_unread} Unread Messages</h3>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </div>
                                    <div className="filter-box-div">
                                        <div className="filter-box">
                                            <div className="filter-icon">
                                                <img src={filter_icon} alt="" />
                                            </div>
                                            <div className="filter-text">
                                                <h3>Filter</h3>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='search'>
                                    <div className="form-group has-search">
                                        <ReactSearchAutocomplete
                                            items={searchItems}
                                            onSearch={handleOnSearch}
                                            onHover={handleOnHover}
                                            onSelect={handleOnSelect}
                                            onFocus={handleOnFocus}
                                            autoFocus
                                            placeholder="Search AWB"
                                        // formatResult={formatResult}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="inbox-title-main-wrap-box-div  scrollbar-4" id="style-4">
                                {allMails?.all_list?.map((data, index) => (
                                    <div className="inbox-title-main-wrap-box-1">
                                        <div className={`inbox-title-main-wrap-box ${data?.is_seen == 0 ? 'inbox-active' : 'msg-read'} ${selectedIndex === index ? 'inbox_select' : ''}`} onClick={() => fetchDetails(data, index)}>
                                            <div className="inbox-title-main-wrap">
                                                <div className="inbox-title-main">
                                                    <div className="inbox-title-text">
                                                        <h3>{data.subject}</h3>
                                                        <h4 className={data.message == 'Not found' ? 'no_awb' : ''}>AWB no. {data.message}</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-time">
                                                    <h4>{data.created_date ? data.created_date : data.created_time}</h4>
                                                    {data.is_seen === 0 && <span>New</span>}
                                                </div>
                                            </div>
                                            <div className="inbox-status-div">
                                                <div className={`inbox-status-left ${data.priority == 'Low' ? 'grn-bx' : (data.priority == 'Medium' ? 'org-bx' : data.priority == 'Critical' ? 'org_red' : '')}`}>
                                                    <div className="inbox-status-icon">
                                                        <img src={data.priority == 'Low' ? green_tag_sm : data.priority == 'Medium' ? orange_tag_sm : data.priority == 'Critical' ? red_tag_sm : ''} alt="" />
                                                    </div>
                                                    <div className="inbox-status-text">
                                                        <h4>{data.priority}</h4>
                                                    </div>
                                                </div>
                                                <div className="inbox-status-left recovery-box grey-bx">
                                                    <div className="inbox-status-text">
                                                        <h4>{data.case_status}</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="inbox-check">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value=""
                                                    id="check_1" />
                                                <label className="form-check-label" for="check_1">
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </Col>
                    {console.log('selectedMail', selectedMail)}
                    <Col lg={7} className="p-0">
                        <div className="lettr-right-div">
                            <div className="letter-main-div scrollbar-5" id="style-5">
                                {selectedMail ? selectedMail?.data?.map((mail, index) => (
                                    <>
                                        {index == 0 &&
                                            <div className="lettr-right-top">
                                                <div className="lettr-right-arrow">
                                                    {/* <Link to="#"><img src={left_arrow} alt="" /> &nbsp;&nbsp;</Link> */}
                                                    <Link to='#' onClick={() => loadDetails(mail)}>AWB No: {mail.awbNumber}</Link>
                                                </div>
                                                <div className="pagi">
                                                    {mail.awbNumber == 'Not found' && <Button onClick={() => handleAsignAwb(mail.id, index)}> Assign AWB </Button>}
                                                    {/* <h4><Link to="/"><span className="lft-1"><img src={left_arrow_1} alt="" /></span></Link>1 of 100
                                            <Link to="/"><span className="rft-1"><img src={right_arrow} alt="" /></span></Link>
                                        </h4> */}
                                                </div>
                                            </div>
                                        }
                                        <div className={`main_replay ${mail.chat_type == 'received' ? 'received' : 'sent'}`}>
                                            <div className="title-div-wrap">
                                                <div className="title-div">
                                                    <div className="title-div-text">
                                                        {/* <h2>{index === 0 ? selectedMail?.subject : `${mail.sender_name} <${mail.sender_email}>`}</h2> */}
                                                        <h4>
                                                            {index === 0 && selectedMail?.subject}
                                                        </h4>
                                                        <h2>
                                                            {mail.sender_name}
                                                        </h2>
                                                        <h3>&lt;{mail.sender_email}&gt;</h3>
                                                    </div>
                                                    <div className="title-right-div">
                                                        <div className="title-right">
                                                            <img src={mail?.is_important == 1 ? star : ''} alt="" />
                                                        </div>
                                                        {mail.chat_type == 'received' &&
                                                            <div className="title-reply-div">
                                                                <Link to="#" onClick={() => handleReply(mail, index)}><span><img src={reply_arrow_1} alt="" /></span>Reply</Link>
                                                                {/* <Link to="#"><span><img src={reply_arrow_2} alt="" /></span>Reply All</Link> */}
                                                                {/* <Link to="#">Forward<span className="title-reply-rit"><img src={forword_icon} alt="" /></span></Link> */}
                                                            </div>}
                                                    </div>
                                                </div>
                                                <div className="title-btm-div">
                                                    <div className="title-btm">
                                                        <div className="title-calender mr-22">
                                                            <div className="calender-icon">
                                                                <img src={calender} alt="" />
                                                            </div>
                                                            <div className="calender-text">
                                                                <h4>{mail?.created_date}</h4>
                                                            </div>
                                                        </div>
                                                        <div className="title-calender">
                                                            <div className="calender-icon">
                                                                <img src={clock} alt="" />
                                                            </div>
                                                            <div className="calender-text">
                                                                <h4>{mail?.created_time}</h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="letter-text-area" dangerouslySetInnerHTML={{ __html: mail?.message || '' }}></div>
                                            {mail?.attachment?.length > 0 &&
                                                <div className="attachment-area-div">
                                                    <div className="attachment-area">
                                                        <h2>Attachments</h2>
                                                    </div>
                                                    <div className="upload-file">
                                                        {mail?.attachment?.map((file, index) => {
                                                            const fileName = file?.file_name;
                                                            const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                            const extension = fileName?.split(".").pop();
                                                            return (
                                                                <>
                                                                    <div key={`ns_${index}`} className="upload-file-1">
                                                                        {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                        ) ? (
                                                                            <>
                                                                                <div className="upload-file-icon">
                                                                                    <img
                                                                                        src={file.file_path}
                                                                                        alt="Preview"
                                                                                        className=''
                                                                                        style={{
                                                                                            maxWidth: "30px",
                                                                                            maxHeight: "30px",
                                                                                            marginRight: "5px",
                                                                                        }}
                                                                                        // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                        onClick={() =>
                                                                                            handleFileClick(file.file_path)
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <span className="d-flex rafilename">
                                                                                    <img src={Docmnt} className="fileimg" />
                                                                                </span>
                                                                            </>
                                                                        )}
                                                                        <div className="upload-text">
                                                                            <h3>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}</h3>
                                                                        </div>

                                                                        <Link to="#" className="slide_dwnldbtn" onClick={() => handleDownload(file.file_path, file.file_name)}>
                                                                            <FontAwesomeIcon icon={faDownload} />
                                                                        </Link>

                                                                        {/* <button
                                                                    className="msg_download"
                                                                    type="button"
                                                                    onClick={() =>
                                                                        handleDownload(file.file_path, file.file_name)
                                                                    }
                                                                >
                                                                    <FontAwesomeIcon icon={faFileArrowDown} />
                                                                </button> */}
                                                                    </div>
                                                                </>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            }
                                            {replyMail === index &&
                                                <div className="letter-reply-area" id='reply'>
                                                    <div className="letter-reply-area-left">
                                                        <div className="letter-reply-area-top">
                                                            <div className="t-div">
                                                                {/* <Link to="/">
                                                                    <div className="t-div-icon">
                                                                        <img src={reply_arrow_1} alt="" />
                                                                    </div>
                                                                </Link> */}
                                                                <div className="t-div-text">
                                                                    <h4>To</h4>
                                                                </div>
                                                            </div>

                                                            <div className="example-div">
                                                                <h4>{mail.sender_email}</h4>
                                                                <Link to="/"><span><img src={cross} alt="" /></span> </Link>
                                                            </div>
                                                        </div>
                                                        <div className="cc-div">
                                                            {/* <Link to="/">cc</Link>
                                                            <Link to="/">Bcc</Link>
                                                            <Link to="/"><img src={plus_1} alt="" /></Link> */}
                                                            <Link to="#" onClick={handleReplyClose}><span><img src={delete_icon} alt="" /></span></Link>
                                                        </div>
                                                    </div>
                                                    <div className="letter-text-wrap">
                                                        <div className="letter-text letter-text-1">
                                                            <h2>{mail.subject}</h2>
                                                            {/* <Link to="/"><span><img src={delete_icon} alt="" /></span></Link> */}
                                                        </div>
                                                        <div className="letter-text position-relative">
                                                            <Form.Group className='mb-2'>
                                                                <Form.Control type="text" placeholder="Enter Your Message here" name='message' as="textarea" rows={8} className='' onChange={(e) => handleMailChange('message', e.target.value)} />
                                                            </Form.Group>

                                                            <div className='d-flex flex-wrap reco_image'>
                                                                {files.map((file, index) => {
                                                                    const fileName = file?.name;
                                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                    const extension = fileName?.split(".").pop();
                                                                    return (
                                                                        <div key={index} className='img-thumbnail'>
                                                                            {file.type.startsWith('image/') ? (
                                                                                <img
                                                                                    src={URL.createObjectURL(file)}
                                                                                    alt="Preview"
                                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                                />
                                                                            ) : (
                                                                                <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                                            )}
                                                                            <span className="rafilename">
                                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                            </span>
                                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-area-box-wrap">
                                                        <div className="text-area-box">
                                                            <div className="text-area-box-icon">
                                                                <img src={user_img} alt="" />
                                                            </div>
                                                        </div>
                                                        <div className="text-input-field">
                                                            <input type="text" className="form-control" id="" placeholder="" />
                                                        </div>
                                                        <div className="text-area-right-wrap">
                                                            <div className="text-area-right">
                                                                <div className="link-icon">
                                                                    <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                                </div>
                                                                <div className='mag_send'>
                                                                    <input
                                                                        type="file"
                                                                        ref={fileInputRef}
                                                                        style={{ display: 'none' }}
                                                                        onChange={handleFileChange}
                                                                        multiple
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="text-area-right">
                                                                <Button variant="primary" onClick={() => sendMessage('R', index)}> Send <FontAwesomeIcon icon={faPaperPlane} /> </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                    </>
                                ))
                                    :
                                    <div className='not_select_item'>
                                        <div>
                                            <img src={Notemail} className='notmail' />
                                            <p>Select an item to read</p>
                                            <span>Nothing is selected</span>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </Col>
                </Row>
            </div >
            <Modal className='addfrom new_mail_modal' show={createMail} onHide={() => createMailClose()} centered size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>New Mail</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Form>
                        <Row className="separate">
                            <Form.Group as={Col} md="12" className="d-flex align-items-center" controlId="formBasicEmail">
                                <Form.Label className='awb_ref'>AWB Reference:</Form.Label>
                                <Form.Control type="text" placeholder="000-0000 0000" name='awbNumber' maxLength={13}
                                    value={mailForm.awbNumber || ''} onChange={(e) => handleMailChange('awbNumber', e.target.value)} />
                            </Form.Group>
                        </Row>

                        <Row className="separate">
                            <Form.Group as={Col} md="12" className="d-flex align-items-center separate" controlId="formBasicEmail">
                                <Form.Label>To:</Form.Label>
                                {/* <Form.Control type="text" placeholder="" name='sender_email' onChange={(e) => handleMailChange('sender_email', e.target.value)} /> */}
                                {/* <Form.Select aria-label="Default select example" name='sender_email' onChange={(e) => handleMailChange('sender_email', e.target.value)}>
                                    {getEmail.map(item => (
                                        <option value={item.value}>{item.label}</option>
                                    ))}
                                </Form.Select> */}
                                <Select
                                    options={getEmail}
                                    onChange={(selected) => {
                                        const selectedValues = selected ? selected.map(option => ({ receiver_id: option.value, receiver_email: option.email })) : [];
                                        setMailForm({ ...mailForm, receiver: selectedValues });
                                    }}
                                    placeholder="example@gmail.com"
                                    className='down_selct'
                                    isMulti
                                    // value={getEmail.find(option => option.value === selectedOpt)}
                                    value={options.value}
                                />
                                
                            </Form.Group>
                            <Form.Group as={Col} md="12" className="d-flex align-items-center " controlId="formBasicEmail">
                                <Form.Label>CC: </Form.Label>
                                <Form.Control type="text" placeholder="" name='cc' onChange={(e) => handleMailChange('cc', e.target.value)} />
                            </Form.Group>
                            {/* <Form.Group as={Col} md="3" >
                                <Form.Select aria-label="Default select example" name='type' value={mailForm.type} onChange={(e) => handleMailChange('type', e.target.value)}>
                                    <option value='A'>Airline</option>
                                    <option value="H">Handler</option>
                                </Form.Select>
                            </Form.Group> */}
                        </Row>
                        <Row className="separate">
                            <Form.Group as={Col} md="12" className="d-flex align-items-center" controlId="formBasicEmail">
                                <Form.Label>Subject:</Form.Label>
                                <Form.Control type="text" placeholder="Enter your text" name='subject' onChange={(e) => handleMailChange('subject', e.target.value)} />
                            </Form.Group>
                        </Row>
                        <Form.Group className='mb-2'>
                            {/* <Form.Control type="text" placeholder="Enter Your Description here" name='message' as="textarea" rows={8} className='' onChange={(e) => handleMailChange('message', e.target.value)} /> */}
                            <MessageBox
                                message_area={"uld"}
                                onMessageChange={(val) => {
                                    setMailForm(prev => ({
                                        ...prev,
                                        message: val
                                    }));
                                }}
                            // commentable_id={selectedRowData.uld_number}
                            // allactivities={selectedRowData.activities}
                            // onReloadDetails={loadDetails}
                            />
                        </Form.Group>
                        {console.log('mailFiles', files)}
                        <div className='d-flex flex-wrap reco_image'>
                            {files.map((file, index) => {
                                const fileName = file?.name;
                                const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                const extension = fileName?.split(".").pop();
                                return (
                                    <div key={index} className='img-thumbnail'>
                                        {file.type.startsWith('image/') ? (
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt="Preview"
                                                style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                            />
                                        ) : (
                                            <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                        )}
                                        <span className="rafilename">
                                            {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                        </span>
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                )
                            })}
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex align-items-center send_mail'>
                        <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                        <Button variant="primary" onClick={() => sendMessage()}> Send <FontAwesomeIcon icon={faPaperPlane} /> </Button>
                    </div>
                    <div className='mag_send'>
                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            multiple
                        />

                    </div>

                </Modal.Footer>
            </Modal>
            <Modal show={assignModal} onHide={closeConfirm} className="addfrom change_type change_type_modal" centered>
                <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
                <Modal.Body>
                    <h3>Assign AWB</h3>
                    <Form.Control
                        type="text"
                        placeholder="000-0000 0000"
                        name='airway_bill'
                        maxLength={13}
                        value={checkAwbData.airway_bill || ''}
                        onChange={(e) => handleInputChange('airway_bill', e.target.value)}
                    />
                    {checkAwb?.length == 1 ?
                        <>
                            <div className='invoice_table'>
                                <Table responsive >
                                    <thead>
                                        <tr>
                                            <th>AWB No.</th>
                                            <th>Case Status</th>
                                            <th>Pieces Involved</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{checkAwb[0]?.awb_number}</td>
                                            <td>{checkAwb[0]?.case_status || ''}</td>
                                            <td>{checkAwb[0]?.pieces_involved}</td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </>
                        :
                        <div className='mt-3'>
                            <p>No existing AWB found. You can add new AWB record.</p>
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-75 mx-auto are_bottom">
                        {checkAwb?.length == 1 ?
                            <>
                                <Button variant="secondary" onClick={closeConfirm}> Cancel </Button>
                                <Button variant="primary" onClick={handleAssign}> Assign to AWB </Button>
                            </>
                            :
                            <>
                                {isCheck &&
                                    <>
                                        <Button variant="secondary" onClick={closeConfirm}> Cancel </Button>
                                        <Button variant="primary" onClick={createNewRecord}> Add New Record </Button>
                                    </>
                                }
                            </>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Inbox
